import { render, staticRenderFns } from "./ArrivalSet.vue?vue&type=template&id=a677a348&scoped=true&"
import script from "./ArrivalSet.vue?vue&type=script&lang=js&"
export * from "./ArrivalSet.vue?vue&type=script&lang=js&"
import style0 from "./ArrivalSet.vue?vue&type=style&index=0&id=a677a348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a677a348",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
